import React from "react";
import icon from "../Details/favicon.ico";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import CV from "../Details/CV.pdf";

export const Details = () => {
	return (
		<div>
			<Navbar className='nav-container'>
				<Container>
					<Navbar.Brand className='MII-icon'>
						<img src={icon} alt='' />
					</Navbar.Brand>
					<div className='details-container'>
						<Nav className='me-auto '>
						<Navbar.Text>
								<a
									href='sample.html#about'
									>
									<div className='nav-link'>About</div>
								</a>
							</Navbar.Text>
							<Navbar.Text>
								<a
									href='sample.html#skills'
									>
									<div className='nav-link'>Skills</div>
								</a>
							</Navbar.Text>
							<Navbar.Text>
								<a
									href='sample.html#projects'
									>
									<div className='nav-link'>Projects</div>
								</a>
							</Navbar.Text>
							<Navbar.Text>
								<a
									href='sample.html#contacts'
									>
									<div className='nav-link'>Contact</div>
								</a>
							</Navbar.Text>
							<Navbar.Text href='#features'>
								<a href={CV} target='_blank' rel='noreferrer'>
									<div className=' nav-link nav-link-CV'>CV</div>
								</a>
							</Navbar.Text>
							
							
							
							
						</Nav>
					</div>
				</Container>
			</Navbar>
		</div>
	);
};
